import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-075e169c"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "modal-content" };
const _hoisted_3 = { class: "modal-title" };
const _hoisted_4 = {
    class: "modal-body",
    style: { "overflow": "hidden" }
};
const _hoisted_5 = { class: "modal-footer" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
const _hoisted_8 = ["disabled"];
const _hoisted_9 = ["disabled"];
const _hoisted_10 = ["disabled"];
const _hoisted_11 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: "modal fade",
        id: _ctx.getId,
        tabindex: "-1",
        onKeypress: _cache[5] || (_cache[5] =
            //@ts-ignore
            (...args) => (_ctx.onKeypress && _ctx.onKeypress(...args))),
        "data-bs-backdrop": "static",
        ref: "dialog"
    }, [
        (_ctx.modelValue)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass('modal-dialog ' + _ctx.modalWidthToUse)
            }, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: _normalizeClass(_ctx.headerClasses),
                        ref: "header"
                    }, [
                        _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.title), 1),
                        (_ctx.cancelXBtn && !_ctx.prohibitCancel)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: _normalizeClass('btn-close ' +
                                    (_ctx.styling === 0 ? 'btn-close-white' : '')),
                                "data-bs-dismiss": "modal",
                                "aria-label": "Close"
                            }, null, 2))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        (_ctx.cancelBtnTxt && !_ctx.prohibitCancel)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-secondary cancel-btn",
                                "data-bs-dismiss": "modal",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.cancelBtn && _ctx.cancelBtn(...args))),
                                disabled: _ctx.isClosing
                            }, _toDisplayString(_ctx.cancelBtnTxt), 9, _hoisted_6))
                            : _createCommentVNode("", true),
                        (_ctx.actionBtnTxt)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                disabled: !_ctx.isActionBtnEnabled || _ctx.isClosing,
                                class: "btn btn-primary action-btn",
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.actionBtn && _ctx.actionBtn(...args)))
                            }, _toDisplayString(_ctx.actionBtnTxt), 9, _hoisted_7))
                            : _createCommentVNode("", true),
                        (_ctx.actionBtnTxt2)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                type: "button",
                                class: "btn btn-primary action-btn2",
                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.otherActionBtn(2))),
                                disabled: _ctx.isClosing
                            }, _toDisplayString(_ctx.actionBtnTxt2), 9, _hoisted_8))
                            : _createCommentVNode("", true),
                        (_ctx.actionBtnTxt3)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                type: "button",
                                class: "btn btn-primary action-btn2",
                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.otherActionBtn(3))),
                                disabled: _ctx.isClosing
                            }, _toDisplayString(_ctx.actionBtnTxt3), 9, _hoisted_9))
                            : _createCommentVNode("", true),
                        (_ctx.actionBtnTxt4)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 4,
                                type: "button",
                                class: "btn btn-primary action-btn2",
                                onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.otherActionBtn(4))),
                                disabled: _ctx.isClosing
                            }, _toDisplayString(_ctx.actionBtnTxt4), 9, _hoisted_10))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.footerTxt !== '')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "modal-footer alert alert-light fs-6 lh-sm",
                            style: { "display": "inline-block" },
                            innerHTML: _ctx.footerTxt
                        }, null, 8, _hoisted_11))
                        : _createCommentVNode("", true)
                ])
            ], 2))
            : _createCommentVNode("", true)
    ], 40, _hoisted_1));
}
